import React, { useContext, useState, useEffect, useRef } from 'react'
import { useHistory } from 'react-router-dom'
import PrimaryButton from '../../atoms/PrimaryButton'
import AlertContext from '../../../context/alert/alertContext'
import ProductContext from '../../../context/product/productContext'
import ProductUserContext from '../../../context/userProduct/productContext'
import AuctionContext from '../../../context/auction/auctionContext'
import UserContext from '../../../context/user/userContext'
import CommonContext from '../../../context/common/commonContext'
import ReportContext from '../../../context/report/reportContext'
import {
    mapData,
    dateTimeFormatFunction,
    capitalize,
} from '../../../common/components'
import { initialFilterFunction } from '../../species/dynamic/common/FieldFunction'
import moment from 'moment'
import { useFormik } from 'formik'
import Loaders from '../../../components/molecules/Loaders'
import CustomDialog from '../../organisms/Dialog'
import { Button } from '@mui/material'
import BaseTablePage from '../../species/dynamic/common/BaseTablePage'
import ImageEdit from '../../organisms/ImageEdit/index'
import bwipjs from 'bwip-js'
import { useReactToPrint } from 'react-to-print'
import CustomCommonContext from '../../../../custom/context/common/commonContext'
import {
    initialFunction,
    editValue,
} from '../../species/dynamic/common/FieldFunction'
import * as Yup from 'yup'
import authContext from '@/product/context/auth/authContext'
import { messageHandlerTable } from '@/product/common/socketHandler'
import openSocket from 'socket.io-client'
import { v4 as uuidv4 } from 'uuid'
import APILogsHistory from '../../organisms/LogHistory/index'

const ListingCommonTable = (props) => {
    const alertContext = useContext(AlertContext)
    const productContext = useContext(ProductContext)
    const auctionContext = useContext(AuctionContext)
    const { getAllUsers } = useContext(UserContext)
    const [openCustomDialog, setopenCustomDialog] = useState(false)
    const [assignAndActiveProduct, setAssignAndActiveProduct] = useState(false)

    const reportContext = useContext(ReportContext)
    const commonContext = useContext(CommonContext)
    const { getGlobalVariable, alldata_all_dropdown } =
        useContext(CustomCommonContext)
    const [isLoading, setIsLoading] = useState(true)

    const { setBidHistoryValue } = commonContext
    const { getAllExportDownload } = reportContext
    const { user, loadUser } = useContext(authContext)

    const { setAlert } = alertContext
    const {
        all_products,
        activelots,
        getAllProducts,
        changeProductStatus,
        projectAction,
        single_project_label,
        getSingleProjectforPrintLabel,
        responseStatus: responseStatusProduct,
        clearResponse: clearResponseProduct,
    } = productContext
    const {
        all_auctions,
        getAllAuctions,
        assignAuctionLot,
        responseStatus: responseStatusAuction,
        clearResponse: clearResponseAuction,
    } = auctionContext
    const userProductContext = useContext(ProductUserContext)
    const { search_alldashboardproducts, getAllDashboardProducts } =
        userProductContext

    const [initialValues, setInitialValues] = useState({})
    const [initialUpdate, setInitialUpdate] = useState(true)
    const [valueLoaded, setValueLoaded] = useState(false)
    const [initialEmptyValues, setInitialEmptyValues] = useState({})
    const [filterArray, setFilterArray] = useState({})
    const [reload, setReload] = useState(false)
    const [updated, setUpdated] = useState(false)
    const [searchProduct, setSearchProduct] = useState(false)
    const [tableBody, setTableBody] = useState([])
    const [viewTableBody, setViewTableBody] = useState([])
    const [dashBoardProduct, setDashBoardProduct] = useState([])
    const [newTableBody, setNewTableBody] = useState([])
    let action = props.action

    const [fieldEditModal, setFieldEditModal] = useState(false)
    const [fieldMapData, setFieldMapData] = useState([])
    const [mapDataValue, setMapDataValue] = useState([])
    const [fieldData, setFieldData] = useState({})
    const [editMapValue, setEditMapValue] = useState([])
    const [printId, setPrintId] = useState({
        id: '0',
        auctionId: '0',
        type: '',
    })
    const [printLableClicked, setPrintLableClicked] = useState(false)
    const [imageManage, setImageManage] = useState({
        popup: false,
        id: 0,
    })

    const toggleImageEditFullScreenPopup = (popup, id) => {
        if (popup) {
            setImageManage({ popup, id })
        } else {
            setImageManage({ popup, id: 0 })
        }
    }

    const [logsManage, setLogsManage] = useState({
        popup: false,
        id: 0,
    })

    const toggleLogsFullScreenPopup = (popup, id) => {
        if (popup) {
            setLogsManage({ popup, id })
        } else {
            setLogsManage({ popup, id: 0 })
        }
    }

    const tableBodyRef = useRef(tableBody)
    useEffect(() => {
        tableBodyRef.current = tableBody
    })

    const viewProductRef = useRef(viewTableBody)
    const userRef = useRef(user)

    /* Start of Formik Selection Action Function */
    const formikSelection = useFormik({
        initialValues: {
            action: '',
            project_id: '',
            auction_id: '',
            date_closed: dateTimeFormatFunction(new Date()),
            mainUpdate: false,
            featured: 0,
            show: 0,
        },
        onSubmit: (values) => {
            setIsLoading(true)
            if (
                values.action === 'open' ||
                values.action === 'removed' ||
                values.action === 'unsold' ||
                values.action === 'date_closed' ||
                values.action === 'relist' ||
                values.action === 'show'
            ) {
                let globalDateTime = global?.defaultDateTimeFormat
                let value = values
                if (value.action === 'date_closed') {
                    value.date_closed = moment(
                        value.date_closed,
                        globalDateTime ? globalDateTime : 'MM-DD-YYYY h:mm a'
                    ).format()
                    if (!moment(value.date_closed).isValid()) {
                        setAlert('Invalid Date', 'error')
                        setIsLoading(false)
                        return false
                    }
                }
                if (Array.isArray(value.project_id)) {
                    value.project_id = value.project_id
                } else {
                    value.project_id = [value.project_id]
                }
                delete value.featured
                changeProductStatus(value)
            } else if (
                values.action === 'add_feature' ||
                values.action === 'remove_feature'
            ) {
                delete values.date_closed
                changeProductStatus(values)
            } else {
                if (assignAndActiveProduct) {
                    values.market_status = 'open'
                }
                if (props.updateProjects) {
                    values.updateProjects = true
                }

                delete values.featured

                assignAuctionLot(values)
            }
        },
    })
    /* End of Formik Selection Action Function */

    /* Start Dynamic filter handle */
    useEffect(() => {
        setInitialValues({})
        setInitialEmptyValues({})
        setInitialUpdate(true)
        setSearchProduct(false)

        if (props.searchInfo?.data && props.searchInfo?.data.length) {
            let mapValueArray = props.searchInfo?.data
            let show = initialFilterFunction(mapValueArray)
            setInitialValues({ ...props.customFilter, ...show })
            setInitialEmptyValues({ ...props.customFilter, ...show })
            setFilterArray(props.searchInfo)

            setTimeout(() => {
                if (Object.keys(show).length) {
                    setSearchProduct(true)
                    setInitialUpdate(false)
                    setReload(!reload)
                }
            }, 1000)
        } else {
            setInitialValues(props.customFilter)
            setInitialEmptyValues(props.customFilter)

            setTimeout(() => {
                if (Object.keys(props.customFilter).length) {
                    setSearchProduct(true)
                    setInitialUpdate(false)
                    setReload(!reload)
                }
            }, 1000)
        }
        setInitialUpdate(false)
    }, [props.searchInfo, props.customFilter, action])
    /* End Dynamic filter handle */

    useEffect(() => {
        loadUser()
    }, [])
    useEffect(() => {
        if (user.emp_type && props.isB == true) {
            if (
                user.emp_type.toLowerCase() === 'seller' ||
                user.emp_type.toLowerCase() === 'employee'
            ) {
                setTableActions(
                    tableActions.filter(
                        (item) => item.label != 'Move to Active'
                    )
                )
            }
        }
    }, [user])

    /* Start of Fetch Table Body Function */

    const formik = useFormik({
        initialValues: {
            limit: props.customLimit ? props.customLimit : 20,
            page: 1,
            orderby: props.orderby ? props.orderby : '',
            order: props.order ? props.order : '',
            filters: initialValues,
            limitOptions: props.limitOptions ? props.limitOptions : null,
        },
        enableReinitialize: false,
        onSubmit: (values) => {
            setIsLoading(true)
            if (props.show_dashboard_values) {
                values.user_id = props.userId
                getAllDashboardProducts(values)
            } else {
                getAllProducts(values)
            }
        },
    })
    // Socket implementation
    const formikRef = useRef(formik.values)
    useEffect(() => {
        formikRef.current = formik.values
    }, [formik.values])
    const handler = (message, type) => {
        messageHandlerTable(
            message,
            viewProductRef.current,
            userRef.current,
            setAlert,
            setViewTableBody,
            type
        )
    }

    useEffect(() => {
        const socket = openSocket(`${process.env.REACT_APP_DOMAIN}/`, {
            transports: ['websocket'],
        })
        socket.on('realclosedupdates', (data) => {
            if (props.show_dashboard_values) {
                getAllDashboardProducts(
                    {
                        limit: 12,
                        page: 1,
                        orderby: 'p.date_closed, asc',
                        order: '',
                        user_id: props.userId,
                        action: action,
                    },
                    'buyerDash'
                )
            } else {
                getAllProducts(formikRef.current)
            }
            // handler(data, 'realclosedupdates')
        })
        socket.on('bidAddtime', (data) => {
            handler(data, 'bidAddtime')
        })
        socket.on('openProductUpdate', (data) => {
            getAllProducts(formikRef.current)
        })
        return () => {
            socket.off('realclosedupdates', (data) => {
                handler(data, 'realclosedupdates')
            })
            socket.off('bidAddtime', (data) => {
                handler(data, 'bidAddtime')
            })
            socket.off('openProductUpdate')
            socket.disconnect()
        }
    }, [])
    useEffect(() => {
        setViewTableBody([])
        setIsLoading(true)
        if (searchProduct) {
            if (props.show_dashboard_values) {
                getAllDashboardProducts(
                    {
                        limit: 12,
                        page: 1,
                        orderby: 'p.date_closed, asc',
                        order: '',
                        user_id: props.userId,
                        action: action,
                    },
                    'buyerDash'
                )
            } else {
                getAllProducts(formik.values)
                getAllAuctions(
                    {
                        page: 1,
                        limit: 20,
                        order: '',
                        orderby: '',
                        filters: {
                            market_status: {
                                value: props.auctionAssign_action
                                    ? props.auctionAssign_action
                                    : ['open', 'draft'],
                                type: 'array',
                                field: 'ac.market_status',
                            },
                            action: {
                                value: '',
                                type: 'in',
                                field: 'ac.market_status',
                            },
                        },
                    },
                    'assignAuctions'
                )
            }
        }
        return () => {
            setViewTableBody([])
        }
    }, [searchProduct])

    useEffect(() => {
        if (all_products) {
            let data = all_products.records.length ? all_products.records : []
            let changeData = data
            if (props.diff_id) {
                changeData.map((value, index) => {
                    if (value.id) {
                        value.uuid = uuidv4()
                    }
                })
            }
            setViewTableBody(changeData)
            viewProductRef.current = changeData
        }
        setIsLoading(false)
    }, [all_products])

    useEffect(() => {
        if (
            search_alldashboardproducts?.from == 'buyerDash' &&
            search_alldashboardproducts?.records?.length
        ) {
            let dynamicValueAssign = search_alldashboardproducts
            setViewTableBody(dynamicValueAssign?.records)
        } else {
            setViewTableBody([])
        }
        setIsLoading(false)
    }, [search_alldashboardproducts])

    useEffect(() => {
        if (tableBody.length && props.showSelectValues) {
            let changeData = [...tableBody]
            let arrayData = props.mapArrayData
            if (props.diff_id) {
                changeData.map((value, index) => {
                    if (value.id) {
                        value.uuid = uuidv4()
                    }
                })
            }
            if (arrayData.length) {
                arrayData.map((data, index) => {
                    if (data.type === 'select') {
                        changeData.map((value, index) => {
                            let fieldname = data.name

                            if (value[fieldname] && value[fieldname] !== null) {
                                if (!data.diff_value) {
                                    let idValue = {}
                                    idValue = alldata_all_dropdown.filter(
                                        (item) =>
                                            item.id ===
                                                parseInt(
                                                    value[fieldname],
                                                    10
                                                ) && item.variable === fieldname
                                    )
                                    if (idValue.length) {
                                        let values = idValue[0]
                                        value[fieldname] = values.description
                                    }
                                }
                            }
                        })
                    }
                })
            }
            setNewTableBody(changeData)
        } else {
            setNewTableBody([])
        }
    }, [tableBody, props.showSelectValues])

    useEffect(() => {
        if (Array.isArray(viewTableBody)) {
            setTableBody(viewTableBody)
        }
    }, [viewTableBody])

    useEffect(() => {
        formik.setFieldValue('filters', initialValues)
    }, [initialValues, updated])

    /* End of Fetch Table Body Function */

    /* Start of Listing Edit Functions */
    const onClickEdit = (id, secondaryID, type) => {
        if (type === 'duplicate') {
            props.toggleFullScreenPopup(
                true,
                type,
                id,
                props.projectType || secondaryID
            )
        } else if (type === 'edit') {
            let projectType = props?.customProjectType
                ? tableBodyRef.current.filter((item) => item.id === id)[0]
                      ?.project_type || null
                : null
            props.toggleFullScreenPopup(
                true,
                type,
                id,
                props?.customProjectType
                    ? projectType
                    : props.projectType || secondaryID
            )
        } else if (type === 'imageview') {
            toggleImageEditFullScreenPopup(true, id)
        } else if (type === 'bidcount') {
            setBidHistoryValue({
                id: id,
                delete_bid:
                    typeof props.delete_bid === 'undefined'
                        ? action === 'open'
                        : props.delete_bid,
                show_declined: props.show_declined
                    ? props.show_declined
                    : false,
                proxy: props.showProxyBid ? props.showProxyBid : false,
                award_bid: props.bid_history_award_bid || false,
                offer: props.bid_history_offer || false,
            })
        } else if (type === 'makeoffer') {
            props.toggleFullScreenPopup(true, type, id)
        } else if (type === 'question') {
            props.toggleFullScreenPopup(true, type, id)
        } else if (type === 'return_notes') {
            props.toggleFullScreenPopup(true, type, id, secondaryID)
        } else if (type === 'private') {
            props.toggleFullScreenPopup(true, 'private', id)
        } else if (type === 'shopify') {
            if (id) {
                window.open(id, '_blank', 'noopener,noreferrer')
            } else {
                setAlert('Please push product to shopify', 'error')
            }
        } else if (type === 'ebay_listing') {
            if (id) {
                window.open(id, '_blank', 'noopener,noreferrer')
            } else {
                setAlert('Please push product to shopify', 'error')
            }
        } else {
            props.toggleFullScreenPopup(true, type, id)
        }
    }

    const printRef = useRef()

    const handlePrint = useReactToPrint({
        content: () => printRef.current,
    })

    const onClickPrint = (id, secondaryID, type) => {
        let selectedProduct = tableBodyRef.current.filter(
            (cat) => parseInt(cat.id, 10) === parseInt(id, 10)
        )

        formikPrint.setFieldValue('id', id)
        formikPrint.setFieldValue('type', type)
        formikPrint.setFieldValue(
            'selectedProduct',
            selectedProduct.length ? selectedProduct[0] : null
        )
        formikPrint.setFieldValue('auctionId', secondaryID)

        if (type === 'apilogs') {
            toggleLogsFullScreenPopup(true, selectedProduct[0]?.project_id)
        } else if (type == 'barcode') {
            if (props.defaultPrintSize) {
                setPrintId({ id: id, auctonId: secondaryID, type: type })
                setTimeout(() => {
                    handlePrint()
                }, 1000)
            } else {
                setopenCustomDialog(true)
            }
        } else if (type == 'label') {
            getSingleProjectforPrintLabel(
                { id: selectedProduct[0]?.project_id },
                'printLabel'
            )
            setPrintLableClicked(true)
        } else {
            setPrintId({ id: id, auctonId: secondaryID, type: type })
            handlePrint()
        }
    }

    useEffect(() => {
        if (
            single_project_label?.record &&
            Object.keys(single_project_label.record).length &&
            single_project_label.from === 'printLabel' &&
            printLableClicked
        ) {
            setPrintId({
                id: props?.printLabelField
                    ? single_project_label.record[props?.printLabelField]
                    : props?.noLotId
                      ? single_project_label.record?.id
                      : single_project_label.record?.lot_id,
                auctonId: single_project_label.record?.auctionid,
                type: 'label',
            })
            setTimeout(() => {
                PrintPreview(
                    single_project_label.record?.id,
                    single_project_label.record?.auctionid,
                    single_project_label.record
                )
            }, 1000)
            setPrintLableClicked(false)
        }
    }, [single_project_label])

    useEffect(() => {
        if (props.permission) {
            formik.values.is_permission_not_required = true
        } else {
            delete formik.values.is_permission_not_required
        }
    }, [props.permission])

    const onClickDelete = (id, secondaryID, type) => {
        onSelectMultiProducts(id, 'removed')
    }

    const onClickView = (id, secondaryID, type) => {
        if (props.fullSiteUrl) {
            window.open(`${props.fullSiteUrl}${id}`)
        } else {
            window.open(`${props.siteUrl}/?productview=${id}`)
        }
    }
    const PrintPreview = (product_id, auction_id, product) => {
        let printWindow
        printWindow = window.open(
            '',
            '',
            'location=1,status=1,scrollbars=1,width=450px,height=135px'
        )
        printWindow.document.write('<html style="margin: 1mm;"><head>')
        printWindow.document.write(
            '<style media="print" type="text/css"> @page { size: auto; margin: 0mm;}</style>'
        )
        printWindow.document.write('</head><body style="margin: 0mm;">')
        printWindow.document.write(
            '<div style="width:100%;text-align:center;">'
        )
        let qrCodeElement = document.getElementById('barcode-canvas')
        let qrCodeImageSrc = qrCodeElement.toDataURL() // Get the QR code as an image source

        printWindow.document.write(
            `<img src="${qrCodeImageSrc}" alt="QR Code" width="200" height="30" />`
        )

        printWindow.document.write(
            '<div style="width:200px;height:70px;margin:auto;">'
        )

        printWindow.document.write('<div style="float: left;width: 70%;">')

        // printWindow.document.write(
        //     `<p style="font-weight: bolder; font-size: 18px; width:100%; height:auto; margin:0; padding-top:5px;text-align:left;">AUCTION EVENT# ${auction_id}
        //         </p>`
        // )
        // printWindow.document.write(
        //     `<p style="font-weight: bolder; font-size: 18px; width:100%; height:auto; margin:0; padding-top:0px;text-align:left;">LOT# ${product_id}
        //         </p>`
        // )
        {
            !props.noEvent
                ? printWindow.document.write(
                      `<p style="font-weight: bolder; font-size: 18px; width:100%; height:auto; margin:0; padding-top:5px;text-align:left;">AUCTION EVENT #${
                          product?.auctionid || ''
                      }
        </p>`
                  )
                : null
        }
        {
            props.printLabelField
                ? printWindow.document.write(
                      `<p style="font-weight: bolder; font-size: 18px; width:100%; height:auto; margin:0; padding-top:0px;text-align:left;">${
                          props.printFieldTitle || ''
                      }#${product[props.printLabelField] || ''}
                </p>`
                  )
                : printWindow.document.write(
                      `<p style="font-weight: bolder; font-size: 18px; width:100%; height:auto; margin:0; padding-top:0px;text-align:left;">LOT #${
                          product?.lot_id || ''
                      }
                </p>`
                  )
        }

        printWindow.document.write('</div>')
        printWindow.document.write('<div style="float: left;width: 30%;">')
        props?.noInvoice
            ? ''
            : printWindow.document.write(
                  `<p style="font-weight: bolder; font-size: 20px; width:100%; height:auto; margin:0;padding-bottom: 10px;padding-top: 10px;text-align:left;">${
                      product?.buynow_common_invoice || ''
                  }
                </p>`
              )
        printWindow.document.write('</div>')
        printWindow.document.write('</div>')
        printWindow.document.write('</div>')
        //here 'forPrintPreview' is the id of the 'div' in current page(aspx).
        printWindow.document.write('</body></html>')
        printWindow.document.close()
        setTimeout(() => {
            printWindow.print()
        }, 1000)
    }
    const getMultipleAction = () => {
        let actionPush = []
        if (!(action === 'closed')) {
            if (!props.noEditBtn) {
                actionPush.push({
                    buttonType: 'edit',
                    clickType: 'edit',
                    clickID: 'id',
                    secondaryClickID: 'view_on',
                    onclick: onClickEdit,
                    tooltipTitle: props.editTooltipTitle
                        ? props.editTooltipTitle
                        : 'Edit lot',
                })
            }

            if (props.duplicate) {
                actionPush.push({
                    buttonType: 'file_copy',
                    clickType: 'duplicate',
                    clickID: 'id',
                    onclick: onClickEdit,
                    tooltipTitle: 'Duplicate lot',
                    showInMenu: true,
                })
            }
        }
        if (props.imageIcon) {
            actionPush.push({
                buttonType: 'image',
                clickType: 'imageview',
                clickID: 'id',
                onclick: onClickEdit,
                tooltipTitle: 'Edit Image',
                showInMenu: true,
            })
        }

        if (props.deleteIcon) {
            actionPush.push({
                buttonType: 'delete',
                clickType: 'delete',
                clickID: 'id',
                onclick: onClickDelete,
                tooltipTitle: 'Delete lot',
                showInMenu: true,
            })
        }
        if (props.preview) {
            actionPush.push({
                buttonType: 'visibility',
                clickType: 'preview',
                clickID: 'id',
                onclick: onClickView,
                secondaryClickID: 'auctionid',
                tooltipTitle: 'Preview',
                showInMenu: true,
            })
        }

        if (props.barcode) {
            actionPush.push({
                buttonType: 'barcode_reader',
                clickType: 'barcode',
                clickID: 'id',
                onclick: onClickPrint,
                secondaryClickID: 'auctionid',
                tooltipTitle: 'Barcode',
                showInMenu: true,
            })
        }
        if (props.printlabel) {
            actionPush.push({
                buttonType: 'text_snippet',
                clickType: 'label',
                clickID: 'id',
                onclick: onClickPrint,
                secondaryClickID: 'auctionid',
                tooltipTitle: 'Print Label',
                showInMenu: true,
            })
        }
        if (props.apilogs) {
            actionPush.push({
                buttonType: 'manage_history',
                clickType: 'apilogs',
                clickID: 'id',
                onclick: onClickPrint,
                secondaryClickID: 'auctionid',
                tooltipTitle: 'API Logs',
                showInMenu: true,
            })
        }
        if (props.qrcode) {
            actionPush.push({
                buttonType: 'qr_code',
                clickType: 'qrcode',
                clickID: 'id',
                onclick: onClickPrint,
                tooltipTitle: 'QR Code',
                showInMenu: true,
            })
        }

        if (
            props.listActionString &&
            props.listActionString.length &&
            action !== 'draft'
        ) {
            if (props.listActionString.includes('bidcount')) {
                actionPush.push({
                    buttonType: props.customButtonIcon ? 'gavel' : 'history',
                    clickType: 'bidcount',
                    clickID: 'id',
                    secondaryClickID: 'user_id',
                    onclick: onClickEdit,
                    tooltipTitle: 'Bid Count',
                    showInMenu: true,
                })
            }

            if (props.listActionString.includes('makeoffer')) {
                actionPush.push({
                    buttonType: 'approval',
                    clickType: 'makeoffer',
                    clickID: 'id',
                    condition: true,
                    conditionValue: {
                        formula: {
                            key1: 'buynow',
                            key2: 1,
                            notation: '===',
                        },
                    },
                    secondaryClickID: 'user_id',
                    onclick: onClickEdit,
                    tooltipTitle: 'Make Offer',
                    showInMenu: true,
                })
            }

            if (props.listActionString.includes('private')) {
                actionPush.push({
                    buttonType: 'verified_user',
                    clickType: 'private',
                    clickID: 'id',
                    secondaryClickID: 'market_status', //'user_id',
                    onclick: onClickEdit,
                    tooltipTitle: props?.tooltipTitle
                        ? props?.tooltipTitle
                        : 'Requested Users',
                })
            }

            if (props.listActionString.includes('questions')) {
                actionPush.push({
                    buttonType: 'quiz',
                    clickType: 'question',
                    clickID: 'id',
                    secondaryClickID: 'user_id',
                    onclick: onClickEdit,
                    tooltipTitle: 'Question & Answers',
                    showInMenu: true,
                })
            }
        }
        if (
            props.listActionString &&
            props.listActionString.includes('shopify') &&
            action !== 'draft'
        ) {
            actionPush.push({
                // buttonType: 'local_mall_icon',
                buttonType: 'shopping_bag',
                clickType: 'shopify',
                clickID: 'shopify_route',
                secondaryClickID: '',
                onclick: onClickEdit,
                tooltipTitle: 'Shopify View',
                showInMenu: true,
            })
        }
        if (
            props.listActionString &&
            props.listActionString.includes('ebay_listing')
        ) {
            actionPush.push({
                // buttonType: 'local_mall_icon',
                buttonType: 'shopping_bag',
                clickType: 'ebay_listing',
                clickID: 'ebay_route',
                secondaryClickID: '',
                onclick: onClickEdit,
                tooltipTitle: 'Ebay View',
                showInMenu: true,
            })
        }

        if (
            props.listActionString &&
            props.listActionString.includes('return_notes')
        ) {
            actionPush.push({
                buttonType: 'assignment_return',
                clickType: 'return_notes',
                clickID: 'id',
                secondaryClickID: 'user_id',
                onclick: onClickEdit,
                tooltipTitle: 'Return Logs',
                showInMenu: true,
            })
        }

        if (props.custonActionBtns) actionPush.push(props.custonActionBtns)
        actionPush =
            props?.removeTableAction?.length &&
            props?.removeTableActionOnTab?.length
                ? actionPush.filter(
                      (item) =>
                          !props?.removeTableAction?.includes(item.clickType) ||
                          !props?.removeTableActionOnTab.includes(action)
                  )
                : actionPush
        return actionPush
    }

    useEffect(() => {
        try {
            if (printId) {
                if (printId.type === 'qrcode') {
                    let canvas = bwipjs.toCanvas('barcode-canvas', {
                        bcid: 'qrcode',
                        text: printId.id.toString(),
                        scale: 1,
                        width: 150,
                        height: 150,
                        includetext: false,
                        textxalign: 'center',
                    })
                } else {
                    let canvas = bwipjs.toCanvas('barcode-canvas', {
                        bcid: 'code128',
                        text: printId.id.toString(),
                        // scale: 8,
                        width: 120,
                        height: 50,
                        includetext: props.includetext ? true : false,
                        textxalign: 'center',
                    })
                }
            }
        } catch (e) {
            console.log('error!')
        }
    }, [printId.id, printId.type])

    /* End of Listing Edit Functions */

    /* Start of Table Top Action Function */
    const [changeStatus, setChangeStatus] = useState(false)
    const [changeStatusShow, setChangeStatusShow] = useState(false)
    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }
    const changeChangeStatusShow = () => {
        setChangeStatusShow(!changeStatusShow)
    }
    const changeCustomStatus = () => {
        setopenCustomDialog(!openCustomDialog)
    }

    const onSelectMultiProducts = (data, action) => {
        formikSelection.values.action = action
        if (Array.isArray(data)) {
            formikSelection.values.project_id = data
        } else {
            formikSelection.values.project_id = [data]
        }
        if (action === 'open' && props?.drafttoActiveStatus) {
            formikSelection.values.draft_status = 'draft'
        }
        formikSelection.setFieldValue('project_id', data)
        formikSelection.values.mainUpdate = false
        formikSelection.values.date_closed = dateTimeFormatFunction(new Date())
        formikSelection.values.auction_id = ''
        if (action === 'auction_assign') {
            if (activeAuctions.length) {
                formikSelection.values.auction_id = activeAuctions[0].value
            }
            setAssignAuction(true)
        } else if (
            action === 'open' ||
            action === 'removed' ||
            action === 'unsold' ||
            action === 'relist'
        ) {
            if (action === 'removed') {
                if (global?.delete_listings_with_bid) {
                    setChangeStatus(true)
                } else {
                    let selectedProjects = tableBodyRef.current.filter(
                        (filter) =>
                            formikSelection.values.project_id.indexOf(
                                filter.id
                            ) !== -1
                    )

                    let bidsCountCheck = selectedProjects.filter(
                        (filter) => filter.bidscount === 0
                    )
                    if (
                        bidsCountCheck.length !==
                        formikSelection.values.project_id.length
                    ) {
                        setAlert(
                            'Listings with bids cannot be deleted',
                            'error'
                        )
                    } else {
                        setChangeStatus(true)
                    }
                }
            } else {
                setChangeStatus(true)
            }
        } else if (action === 'add_feature') {
            formikSelection.values.mainUpdate = true
            formikSelection.values.featured = 1
            setChangeStatus(true)
        } else if (action === 'remove_feature') {
            formikSelection.values.mainUpdate = true
            formikSelection.values.featured = 0
            setChangeStatus(true)
        } else if (action === 'date_closed') {
            formikSelection.values.mainUpdate = true
            setChangeStatus(true)
        } else if (action === 'show') {
            formikSelection.values.mainUpdate = false
            changeChangeStatusShow(true)
        }
    }
    useEffect(() => {
        if (responseStatusProduct) {
            if (responseStatusProduct.status === 'success') {
                if (responseStatusProduct.from === 'productchange') {
                    setChangeStatus(false)
                    setChangeStatusShow(false)
                    getAllProducts(formik.values)
                } else if (responseStatusProduct.from === 'projectAction') {
                    props.toggleFullScreenPopup(false)
                    getAllProducts(formik.values)
                } else if (
                    responseStatusProduct.from === 'bulkProjectImageAction'
                ) {
                    getAllProducts(formik.values)
                } else if (responseStatusProduct.from === 'bulkProjectAction') {
                    getAllProducts(formik.values)
                }
            }
            clearResponseProduct()
        }
    }, [responseStatusProduct])

    const mapDataValueRef = useRef(mapDataValue)
    useEffect(() => {
        mapDataValueRef.current = mapDataValue
    })

    /* Start of Table Top Value Function */
    const [tableActions, setTableActions] = useState([])
    let incomingAction = props.tableActionString

    useEffect(() => {
        let tempTableActions = [
            {
                label: 'Move to Active',
                icon: <span className="material-icons">low_priority</span>,
                onclick: onSelectMultiProducts,
                type: 'open',
                action: 'draft',
                id: 'product_movetoactive',
            },
            {
                label: 'Assign to Auction',
                icon: <span className="material-icons">add_task</span>,
                onclick: onSelectMultiProducts,
                type: 'auction_assign',
                action: 'draft,open',
                id: 'product_assigntoauction',
            },
            {
                label: 'Delete',
                icon: <span className="material-icons">delete</span>,
                onclick: onSelectMultiProducts,
                type: 'removed',
                action: 'draft,open',
                id: 'product_delete',
            },
            {
                label: 'Relist',
                icon: <span className="material-icons">restart_alt</span>,
                onclick: onSelectMultiProducts,
                type: 'relist',
                action: 'unsold',
                id: 'product_relist',
            },
            {
                label: 'Move to Unsold',
                icon: <span className="material-icons">low_priority</span>,
                onclick: onSelectMultiProducts,
                type: 'unsold',
                action: 'open,sold,cancelled',
                id: 'product_movetounsold',
            },
            {
                label: 'User View',
                icon: <span className="material-icons">preview</span>,
                onclick: onSelectMultiProducts,
                type: 'show',
                action: 'sold',
                id: 'product_movetoshow',
            },
            {
                label: 'Change End Date',
                icon: <span className="material-icons">today</span>,
                onclick: onSelectMultiProducts,
                type: 'date_closed',
                action: 'open,draft',
                id: 'product_changeenddate',
            },
        ]
        tempTableActions = tempTableActions.filter((d) => {
            return d.action.toString().split(',').includes(action) &&
                incomingAction.length
                ? incomingAction.includes(d.type)
                : false
        })
        if (action === '') {
            if (props.tableActionString.includes('all_removed')) {
                tempTableActions.push({
                    label: 'Delete',
                    icon: <span className="material-icons">delete</span>,
                    onclick: onSelectMultiProducts,
                    type: 'removed',
                    action: '',
                })
            }

            if (props.tableActionString.includes('all_auction_assign')) {
                tempTableActions.push({
                    label: 'Assign to Auction',
                    icon: <span className="material-icons">add_task</span>,
                    onclick: onSelectMultiProducts,
                    type: 'auction_assign',
                    action: '',
                })
            }
        }

        if (props.feature) {
            tempTableActions.push(
                {
                    label: 'Add Feature Item',
                    icon: <span className="material-icons">add</span>,
                    onclick: onSelectMultiProducts,
                    type: 'add_feature',
                    action: '',
                },
                {
                    label: 'Remove Feature Item',
                    icon: <span className="material-icons">remove</span>,
                    onclick: onSelectMultiProducts,
                    type: 'remove_feature',
                    action: '',
                }
            )
        }
        tempTableActions = props?.removeTableAction?.length
            ? tempTableActions.filter(
                  (item) => !props?.removeTableAction?.includes(item.type)
              )
            : tempTableActions

        setTableActions(tempTableActions)
    }, [action, incomingAction])
    /* End of Table Top Value Function */

    /* Start of Table Body Value Function */
    const [arrayValue, setArrayValue] = useState([])
    useEffect(() => {
        if (props.tableValue.length) {
            let dynamicValueAssign = props.tableValue
            if (action !== 'sold' && action !== 'relisted') {
                dynamicValueAssign = dynamicValueAssign.filter(
                    (item) =>
                        item.field !== 'action' &&
                        item.field !== 'winner_email' &&
                        item.field !== 'buynow_common_invoice' &&
                        item.field !== 'buynow_paid_date' &&
                        item.field !== 'buynow_qty' &&
                        item.field !== 'buynow_amount' &&
                        item.field !== 'winner_first_name,winner_last_name'
                )
            } else if (action === 'sold') {
                dynamicValueAssign = dynamicValueAssign.filter(
                    (item) =>
                        item.field !== 'action' &&
                        item.field !== 'rprice' &&
                        item.field !== 'wprice'
                )
            }
            if (props.dynamic_lot_id && action === 'draft') {
                dynamicValueAssign = dynamicValueAssign.filter(
                    (item) => item.field !== 'lot_id'
                )
            }
            if (props.dynamic_lot_id && action !== 'draft') {
                dynamicValueAssign = dynamicValueAssign.filter(
                    (item) => item.field !== 'id'
                )
            }

            if ((action === 'sold' || action === 'relisted') && props.diff_id) {
                dynamicValueAssign = dynamicValueAssign.filter(
                    (item) => item.field !== 'id'
                )
            }

            if (action !== 'sold' && action !== 'relisted' && props.diff_id) {
                dynamicValueAssign = dynamicValueAssign.filter(
                    (item) => item.field !== 'buynow_project_id'
                )
            }

            // dynamicValueAssign = dynamicValueAssign.filter((item) =>
            //     item.field !== 'action'
            // ? action !== 'sold' && action !== 'relisted'
            //     ? item.field !== 'winner_email' &&
            //       item.field !== 'buynow_common_invoice' &&
            //       item.field !== 'buynow_paid_date' &&
            //       item.field !== 'buynow_qty' &&
            //       item.field !== 'buynow_amount' &&
            //       item.field !== 'winner_first_name,winner_last_name'
            //     : null
            // :
            // action === 'sold'
            //   ? item.field !== 'wprice'
            //   : true
            //   false,
            let index = dynamicValueAssign.findIndex((e) => e.field == 'action')
            let arrayVal = []
            if (!props.show_dashboard_values && !props.noaction) {
                if (index > 0) {
                    arrayVal = dynamicValueAssign.filter(
                        (item) => item.field !== 'action'
                    )
                    arrayVal.push({
                        name: 'action',
                        field: 'action',
                        type: 'button',
                        isMultiple: true,
                        clickID: 'id',
                        sort: false,
                        firstChild: false,
                        disablePadding: false,
                        label: 'Action',
                        isMultiple: getMultipleAction(),
                        tableShow: 1,
                    })
                } else {
                    arrayVal = dynamicValueAssign
                    arrayVal.push({
                        name: 'action',
                        field: 'action',
                        type: 'button',
                        isMultiple: true,
                        clickID: 'id',
                        sort: false,
                        firstChild: false,
                        disablePadding: false,
                        label: 'Action',
                        isMultiple: getMultipleAction(),
                        tableShow: 1,
                    })
                }
                setArrayValue(arrayVal)
            } else {
                setArrayValue(dynamicValueAssign)
            }
        }
    }, [props.tableValue, action])
    /* End of Table Body Value Function */

    /* Start of Bulk Upload Function */
    const [bulkPopup, setBulkPopup] = useState(false)
    const toggleBulkPopup = (popup) => {
        setBulkPopup({ popup })
    }
    /* End of Bulk Upload Function */

    /* Start of Search Info Function */
    const searchInfo = filterArray.data?.length
        ? { formik: formik, ...filterArray }
        : { formik: formik }
    /* End of Search Info Function */

    let lotStatusArr = [
        {
            label: 'Active',
            id: 'open',
        },
        {
            label: 'Sold',
            id: 'sold',
        },
        {
            label: 'Unsold',
            id: 'unsold',
        },
        {
            label: 'Draft',
            id: 'draft',
        },
        {
            label: 'Relisted',
            id: 'relisted',
        },
    ]

    const [additionalFilterCustom, setAdditionalFilterCustom] = useState({
        auctions: '',
        lots: '',
    })

    const additionalFilterFormik = useFormik({
        initialValues: additionalFilterCustom,
        validationSchema: null,
        enableReinitialize: true,
        onSubmit: (values) => {
            console.log(values)
        },
    })

    const additionalFilterMapData = [
        {
            label: 'Inventory status',
            type: 'select',
            placeholder: 'Inventory status',
            class: `lotStatus ${
                additionalFilterFormik.values.auctions ? 'd-none' : ''
            }`,
            options: lotStatusArr?.map((opt) => {
                let updatedObject = {}
                updatedObject.value = opt.id
                updatedObject.show = opt.label
                return updatedObject
            }),
            name: 'lots',
            formik: additionalFilterFormik,
        },
        {
            label: 'Edit sequence',
            type: 'select',
            placeholder: 'Edit sequence',
            class: ` ${additionalFilterFormik.values.lots ? 'd-none' : ''}`,
            options: props.auctionList?.records.map((opt) => {
                let updatedObject = {}
                updatedObject.value = opt.id
                updatedObject.show = `${opt.title} - ${capitalize(
                    opt.market_status
                )} - ${opt.id}`
                return updatedObject
            }),
            name: 'auctions',
            formik: additionalFilterFormik,
        },
    ]

    useEffect(() => {
        if (props.additionalFilterCallBack) {
            props.additionalFilterCallBack(additionalFilterFormik.values)
        }
    }, [additionalFilterFormik.values])

    useEffect(() => {
        if (props.additionalFilterCustom) {
            setAdditionalFilterCustom({
                auctions: props.additionalFilterCustom.auctions || '',
                lots: props.additionalFilterCustom.lots || '',
            })
        }
    }, [props.additionalFilterCustom])

    /* Start Auction Lot Action Function */
    const [assignAuction, setAssignAuction] = useState(false)
    const [activeAuctions, setActiveAuctions] = useState([])
    const changeAssignAuction = () => {
        setAssignAuction(!assignAuction)
    }
    useEffect(() => {
        const lotsToShow = []
        if (
            all_auctions &&
            all_auctions.records.length > 0 &&
            all_auctions.from === 'assignAuctions'
        ) {
            let auctionData = all_auctions.records

            if (props.show_status) {
                auctionData.map((lot) => {
                    lotsToShow.push({
                        value: lot.id,
                        show: `${lot.title} (${
                            lot.future_active
                                ? 'Upcoming'
                                : capitalize(lot.market_status)
                        })`,
                    })
                })
            } else {
                auctionData.map((lot) => {
                    lotsToShow.push({ value: lot.id, show: lot.title })
                })
            }

            setActiveAuctions(lotsToShow)
        } else {
            setActiveAuctions([])
        }
    }, [all_auctions])

    const assignAuctionData = {
        formik: formikSelection,
        data: [
            {
                label: 'Select an existing Auction',
                type: 'select',
                placeholder: 'Select an auction',
                class: 'col-12',
                options: activeAuctions,
                name: 'auction_id',
            },
        ],
    }
    useEffect(() => {
        if (responseStatusAuction) {
            if (
                responseStatusAuction.status === 'success' &&
                responseStatusAuction.from === 'auctionLot'
            ) {
                setAssignAuction(false)
                getAllProducts(formik.values)
            }
            clearResponseAuction()
        }
    }, [responseStatusAuction])
    /* End of Auction Lot Action Function */

    /* Start Date Close Function */
    const dateClosed = {
        formik: formikSelection,
        data: [
            {
                label: 'Change End Date *',
                placeholder: 'Enter End Date',
                disablePast: true,
                type: 'datetime',
                class: `col-12 ${
                    formikSelection.values.mainUpdate ? '' : 'd-none'
                }`,
                name: 'date_closed',
                minDate: dateTimeFormatFunction(new Date()),
                minDateMessage: `Date should not be before minimal date ${dateTimeFormatFunction(
                    new Date()
                )}`,
            },
        ],
    }
    /* End  Date Close Function */

    const [fieldValues, setFieldValues] = useState({})
    const changeFieldEditModal = (fieldValue, data) => {
        setFieldEditModal(true)
        let fieldUpdateData = []
        if (
            fieldValue.type === 'imagewithurl' &&
            fieldValue.field === 'avatar'
        ) {
            let imageField = props.dynamicFieldValues
                ?.filter((d) => d.name === 'uploadimages')
                .map((data) => {
                    data.avatar = true
                    return data
                })

            fieldUpdateData = imageField
        } else if (
            fieldValue.type === 'datetime' &&
            fieldValue.field === 'date_closed'
        ) {
            let dateField = props.dynamicFieldValues
                ?.filter((d) => d.name === 'date_closed')
                .map((data) => {
                    data.disablePast = true
                    return data
                })

            fieldUpdateData = dateField
        } else {
            fieldUpdateData = props.dynamicFieldValues?.filter(
                (d) => d.name == fieldValue.field
            )
        }

        let dataVal = fieldUpdateData.length ? fieldUpdateData[0] : null
        setFieldData({ ...dataVal, class: '' })
        let mapValue = {}
        fieldUpdateData.map((data, index) => {
            if (data.sub_field) {
                mapValue = props.dynamicFieldValues?.filter(
                    (d) => d.name == data.sub_field
                )
            }
        })
        if (mapValue.length) {
            mapValue[0].class = 'col-sm-12 col-12'
            fieldUpdateData.push(mapValue[0])
        }
        if (fieldUpdateData.length) {
            fieldUpdateData[0].class = 'col-sm-12 col-12'
        }

        setFieldMapData(fieldUpdateData)
        setFieldValues(data)
    }

    const [dynamicFieldInitialValues, setDynamicFieldInitialValues] = useState(
        {}
    )

    const [dynamicFieldValidationSchema, setDynamicFieldValidationSchema] =
        useState(null)

    useEffect(() => {
        setValueLoaded(false)
        setDynamicFieldInitialValues({})
        setMapDataValue([])
        let custom = { id: 0 }

        let { tempMapData, show } = initialFunction(
            fieldMapData,
            alldata_all_dropdown,
            subLevelOptions
        )
        setDynamicFieldInitialValues({ ...custom, ...show })

        setMapDataValue(tempMapData)
        setEditMapValue(tempMapData)
        setTimeout(() => {
            if (tempMapData.length) {
                setValueLoaded(true)
                setReload(!reload)
            }
        }, 1000)
    }, [fieldMapData])
    const dynamicFieldFormik = useFormik({
        initialValues: dynamicFieldInitialValues,
        validateOnBlur: false,
        validationSchema: dynamicFieldValidationSchema,
        enableReinitialize: true,
        onSubmit: (values) => {
            if (values.date_closed && values.date_closed !== '') {
                values.date_closed = moment(
                    values.date_closed,
                    'MM-DD-YYYY h:mm a'
                ).format()
            }
            projectAction(values)
            setFieldEditModal(false)
        },
    })
    useEffect(() => {
        if (mapDataValueRef.current.length) {
            let tempMapData = mapDataValueRef.current
            tempMapData.map((data) => {
                if (
                    data.type === 'select' &&
                    parseInt(data.sub_select, 10) === 1
                ) {
                    if (parseInt(data.sub_level, 10) > 0) {
                        data.options = subLevelOptions(data)
                        console.log(data.options, 'optt')
                    }
                }
                if (data.type === 'select' && data.name === 'state') {
                    data.options = subStateOptions(data)
                }
                if (
                    data.type === 'multiselect' &&
                    parseInt(data.sub_select, 10) === 1
                ) {
                    if (parseInt(data.sub_level, 10) > 0) {
                        data.options = subLevelOptions(data)
                    }
                }
            })
        }
    }, [dynamicFieldFormik.values])
    /* End of Table Top Action Function */
    const subLevelOptions = (data) => {
        let valueDrop = []
        valueDrop = alldata_all_dropdown
            .filter((subcat) => {
                if (
                    dynamicFieldFormik.values[data.sub_field] &&
                    parseInt(subcat.level, 10) === parseInt(data.sub_level, 10)
                ) {
                    if (
                        parseInt(subcat.active, 10) === 1 ||
                        (dynamicFieldFormik.values[data.name] &&
                            dynamicFieldFormik.values[data.name] === subcat.id)
                    ) {
                        if (data.diff_value) {
                            let mainId = alldata_all_dropdown.filter(
                                (item) =>
                                    item.value ===
                                    dynamicFieldFormik.values[data.sub_field]
                            )[0]

                            return (
                                parseInt(subcat.level_id, 10) ===
                                parseInt(mainId.id, 10)
                            )
                        } else {
                            return (
                                parseInt(
                                    dynamicFieldFormik.values[data.sub_field],
                                    10
                                ) === parseInt(subcat.level_id, 10)
                            )
                        }
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            })
            .map((subcat) => {
                let subCategoryChanged = {}
                subCategoryChanged.show = subcat.description
                subCategoryChanged.value = data.diff_value
                    ? subact.value
                    : subcat.id
                return subCategoryChanged
            })
        if (valueDrop.length) {
            return valueDrop
        } else {
            return valueDrop
        }
    }

    useEffect(() => {
        if (Object.keys(fieldValues).length) {
            let arrayData = props.mapArrayData
            const changeValues = Object.assign({}, fieldValues)
            if (arrayData.length) {
                arrayData.map((data, index) => {
                    if (data.type === 'select') {
                        if (
                            changeValues[data.name] &&
                            changeValues[data.name] !== null
                        ) {
                            let fieldname = data.name
                            if (!data.diff_value) {
                                let idValue = {}
                                idValue = alldata_all_dropdown.filter(
                                    (item) =>
                                        item.description ===
                                            changeValues[data.name] &&
                                        item.variable === fieldname
                                )
                                if (idValue.length) {
                                    let values = idValue[0]
                                    changeValues[data.name] = values.id
                                }
                            }
                        }
                    }
                })
            }

            let objectPush = editValue(editMapValue, changeValues)
            setDynamicFieldInitialValues(objectPush)
        }
    }, [fieldValues, editMapValue])

    const barcodeValidation = Yup.object({
        barcodeSize: Yup.string().required('Required !'),
    })

    const formikPrint = useFormik({
        initialValues: {
            id: 0,
            type: '',
            barcodeSize: '',
            auctionId: 0,
            selectedProduct: null,
        },
        validationSchema: barcodeValidation,
        onSubmit: async (values) => {
            setPrintId({
                id: values.id,
                auctionId: values.auctionId,
                type: values.type,
            })
            handlePrint()
            setopenCustomDialog(false)
            resetForm()
            // try {
            //     // Create a new instance of the object
            //     const browserPrint = new ZebraBrowserPrintWrapper()
            //     console.log('11111')
            //     // Select default printer
            //     const defaultPrinter = await browserPrint.getDefaultPrinter()
            //     console.log('22222')
            //     // Set the printer
            //     browserPrint.setPrinter(defaultPrinter)
            //     console.log('33333')
            //     // Check printer status
            //     const printerStatus = await browserPrint.checkPrinterStatus()
            //     console.log('444444', printerStatus)
            //     // Check if the printer is ready
            //     if (printerStatus.isReadyToPrint) {
            //         // ZPL script to print a simple barcode
            //         const zpl = `^XA
            //                 ^BY2,2,100
            //                 ^FO20,20^BC^FD${serial}^FS
            //                 ^XZ`

            //         browserPrint.print(zpl)
            //     } else {
            //         console.log('Error/s', printerStatus.errors)
            //     }
            // } catch (error) {
            //     console.log('ERRR', error)
            //     throw new Error(error)
            // }
        },
    })

    const resetForm = () => {
        formikPrint.values.id = 0
        formikPrint.values.type = ''
        formikPrint.values.barcodeSize = ''
        formikPrint.values.selectedProduct = ''
        formikPrint.handleReset()
    }

    const cancelFunction = () => {
        setopenCustomDialog(false)
        resetForm()
    }
    const resettingForm = () => {
        setInitialValues(initialEmptyValues)
        setUpdated(!updated)
        setReload(!reload)
    }

    const barcodeSize = [
        {
            label: 'Barcode Size',
            placeholder: 'Select',
            class: 'col-12',
            type: 'select',
            options: [
                { value: 'zebra-small', show: 'Zebra Small (1" x 1")' },
                {
                    value: 'zebra-medium',
                    show: 'Zebra Medium (2-1/4" x 1-1/4")',
                },
                { value: 'zebra-large', show: 'Zebra Large (3" x 2")' },
                { value: 'dymo-small', show: 'Dymo Small (1" x 2-1/8")' },
                { value: 'dymo-medium', show: 'Dymo Medium (2-1/4" x 1-1/4")' },
                { value: 'dymo-large', show: 'Dymo Large (2-5/16" x 4")' },
                { value: 'avery-small', show: 'Avery Small (1.25" x 1.75")' },
                { value: 'avery-medium', show: 'Avery Medium (2.25" x 3.25")' },
                { value: 'avery-large', show: 'Avery Large (2-1/8" x 4-1/2")' },
            ],
            name: 'barcodeSize',
            formik: formikPrint,
        },
    ]

    return (
        <>
            <div ref={printRef} className="printBarcode">
                <canvas
                    id="barcode-canvas"
                    className={
                        formikPrint.values.type === 'barcode' &&
                        props.defaultPrintSize
                            ? props.defaultPrintSize
                            : formikPrint.values.barcodeSize
                              ? formikPrint.values.barcodeSize
                              : ''
                    }
                ></canvas>

                {formikPrint.values.type === 'barcode' ? (
                    <>
                        <h4>ID: {formikPrint.values.id} </h4>
                        {formikPrint.values.auctionId && props.showAuctionId ? (
                            <h4>Auction ID: {formikPrint.values.auctionId} </h4>
                        ) : null}

                        {formikPrint.values.selectedProduct ? (
                            <>
                                {formikPrint.values.barcodeSize ===
                                'zebra-large' ? (
                                    <div>
                                        <h4>
                                            Title:{' '}
                                            {
                                                formikPrint.values
                                                    .selectedProduct.title
                                            }{' '}
                                        </h4>
                                    </div>
                                ) : null}
                            </>
                        ) : null}
                    </>
                ) : null}
            </div>
            <div className="dashboard listing maillisting">
                {initialUpdate ? (
                    <Loaders name="table" isLoading={isLoading} />
                ) : (
                    <BaseTablePage
                        formik={formik}
                        arrayValue={arrayValue}
                        isLoading={isLoading}
                        searchInfo={searchInfo}
                        tableBody={
                            props.showSelectValues ? newTableBody : tableBody
                        }
                        tableActions={tableActions}
                        allData={
                            props.show_dashboard_values
                                ? search_alldashboardproducts
                                : all_products
                        }
                        editFunction={projectAction}
                        changeTableFunction={
                            props.show_dashboard_values
                                ? getAllDashboardProducts
                                : getAllProducts
                        }
                        editTableCell={changeFieldEditModal}
                        enableEditTableCell={props.enableEditTableCell}
                        enableColumnEdit={props.enableColumnEdit}
                        dynamicFieldValues={props.dynamicFieldValues}
                        reorderId={props.reorderId}
                        ignoreEditArray={[
                            'id',
                            'created_at',
                            'updated_at',
                            'projectcount',
                            'market_status',
                            'status',
                            'action',
                            'as_employees_emp_firstname,as_employees_emp_lastname',
                            'wprice',
                            'bidscount',
                            'auctiontitle',
                        ]}
                        additionalFilter={props.additionalFilter}
                        additionalFilterMapData={additionalFilterMapData}
                        additionalFilterFormik={additionalFilterFormik}
                        propertyColumnReOrder={props.propertyColumnReOrder}
                        reorder={props.reorder}
                        hideCompactView={props.hideCompactView}
                        advFilters={props.advFilters}
                        resetForm={resettingForm}
                        columnStorageVariable={props.columnStorageVariable}
                        diff_id={props.diff_id}
                    />
                )}
            </div>
            <CustomDialog
                title={'Assign to an Auction'}
                open={assignAuction}
                function={changeAssignAuction}
            >
                <h5>Select from an existing auction to assign</h5>
                <form
                    onSubmit={formikSelection.handleSubmit}
                    autoComplete="nofill"
                >
                    <div className="row lotassignCnf">
                        {mapData(assignAuctionData)}
                    </div>
                    <div className="actionWrapper">
                        <Button
                            id="tableView_cancel"
                            onClick={() => changeAssignAuction()}
                        >
                            Cancel
                        </Button>
                        <div className="mr-2">
                            {' '}
                            <PrimaryButton
                                id="product_table_submit"
                                label="Assign"
                                onClick={() => {
                                    ;(setAssignAndActiveProduct(false),
                                        formikSelection.handleSubmit())
                                }}
                            />
                        </div>
                        {props.assignAndActive && (
                            <PrimaryButton
                                id="product_table_submit"
                                onClick={() => {
                                    ;(setAssignAndActiveProduct(true),
                                        formikSelection.handleSubmit())
                                }}
                                label="Assign And Active"
                            />
                        )}
                    </div>
                </form>
            </CustomDialog>

            {/* <CustomDialog
                title={'Change product status'}
                open={changeStatus}
                function={changeChangeStatus}
            >
                <h5>Are you sure you want to change the status ?</h5>
                <div className="row">{mapData(dateClosed)}</div>
                <div className="actionWrapper">
                    <Button
                        id="product_cancel"
                        onClick={() => changeChangeStatus()}
                    >
                        Cancel
                    </Button>
                    <form
                        onSubmit={formikSelection.handleSubmit}
                        autoComplete="nofill"
                    >
                        <PrimaryButton
                            id="product_table_confirm"
                            type="submit"
                            label="Confirm"
                        />
                    </form>
                </div>
            </CustomDialog> */}
            <CustomDialog
                title={'Choose Barcode Size'}
                open={openCustomDialog}
                function={changeCustomStatus}
            >
                <form onSubmit={formikPrint.handleSubmit} autoComplete="nofill">
                    <div className="row">
                        <div className="col-12">
                            <div className="row">{mapData(barcodeSize)}</div>
                        </div>
                    </div>
                    <div className="actionWrapper">
                        <Button onClick={() => cancelFunction()}>Cancel</Button>
                        <PrimaryButton type="submit" label="Confirm" />
                    </div>
                </form>
            </CustomDialog>
            <CustomDialog
                title={'Change Product status'}
                open={changeStatus}
                function={changeChangeStatus}
            >
                <h5>
                    {formikSelection.values.action === 'closenow'
                        ? 'Are you sure you want to close the auctions and lots related ?'
                        : 'Are you sure you want to change the status ?'}
                </h5>
                {formikSelection.values.action === 'date_closed' && (
                    <div className="row">{mapData(dateClosed)}</div>
                )}
                <div className="actionWrapper">
                    <Button
                        id="auction_cancel"
                        onClick={() => changeChangeStatus()}
                    >
                        Cancel
                    </Button>
                    <form
                        onSubmit={formikSelection.handleSubmit}
                        autoComplete="nofill"
                    >
                        <PrimaryButton
                            id="auction_table_submit"
                            type="submit"
                            label="Confirm"
                        />
                    </form>
                </div>
            </CustomDialog>

            <CustomDialog
                className="editFieldModal"
                title={`Edit ${fieldData?.label}`}
                open={fieldEditModal}
                function={() => setFieldEditModal(!fieldEditModal)}
                disableBackdropClick
            >
                {valueLoaded ? (
                    <form
                        onSubmit={dynamicFieldFormik.handleSubmit}
                        autoComplete="nofill"
                    >
                        <div className="row">
                            <div className="col-12">
                                {mapData({
                                    formik: dynamicFieldFormik,
                                    data: mapDataValue,
                                })}
                            </div>
                        </div>
                        <div className="actionWrapper">
                            <Button onClick={() => setFieldEditModal(false)}>
                                Cancel
                            </Button>
                            <PrimaryButton type="submit" label="Confirm" />
                        </div>
                    </form>
                ) : null}
            </CustomDialog>
            <CustomDialog
                title={'View on Website'}
                open={changeStatusShow}
                function={changeChangeStatusShow}
                closeBtn={true}
            >
                <h5>{'Are you sure you want to continue with this action'}</h5>

                <div className="actionWrapper">
                    {/* <Button
                        id="auction_cancel"
                        onClick={() => changeChangeStatusShow()}
                    >
                        Cancel
                    </Button> */}

                    <PrimaryButton
                        id="auction_table_submit"
                        type="submit"
                        onClick={() => {
                            formikSelection.setFieldValue('show', 1)
                            formikSelection.handleSubmit()
                        }}
                        label="Add"
                    />
                    <Button
                        id="auction_table_submit"
                        type="submit"
                        onClick={() => {
                            formikSelection.setFieldValue('show', 0)
                            formikSelection.handleSubmit()
                        }}
                        label="Remove"
                    >
                        Remove
                    </Button>
                </div>
            </CustomDialog>

            <ImageEdit
                data={imageManage}
                function={toggleImageEditFullScreenPopup}
            />
            <APILogsHistory
                data={logsManage}
                function={toggleLogsFullScreenPopup}
            />
        </>
    )
}

export default ListingCommonTable
// export default React.memo(ListingCommonTable, (oldProps, newProps) => oldProps === newProps)
